import { useClinicGroup } from '@/hooks/useClinicGroups'
import { useViewMode } from '@/stores/viewMode'
import { PageHeader } from '@/components/PageHeader'
import ClinicGroupInfo from './ClinicGroupInfo'

export default function ClinicGroupPage() {
  const { id: groupId } = useViewMode()
  const { clinicGroup, isLoading } = useClinicGroup(groupId)

  return (
    <div className="space-y-6">
      <PageHeader title="集團資訊" description="管理診所集團資訊" level="section" />
      <ClinicGroupInfo clinicGroup={clinicGroup} isLoading={isLoading} />
    </div>
  )
}
